<lds-empty-state
  heading="Unauthorised"
  message="Sorry, looks like you are not authorised to access this page. For assistance, please contact your support team.">
</lds-empty-state>
